/**
 * SEMILLA por casa — lo único que la API AÚN NO sirve: las fuentes
 * conectadas (BC/PBI, modelo de conectores con F5c: I-8/I-9), la telemetría
 * por casa y el rastro fino. Nombre, sector, sabor y recuento de directivos
 * son REALES (§5, metadatos) y salen del contrato: aquí no viven.
 *
 * Está indexada por slug A PROPÓSITO: una casa real que se dé de alta hoy no
 * casa con ninguna entrada y se pinta con su verdad — sin fuentes, sin
 * telemetría, sin rastro inventado. Lo sembrado se marca «fase dev» allí
 * donde se enseña; ninguna cifra de aquí se presenta como medida.
 */
import type { ReactNode } from "react";
export interface CasaSeed {
  bc?: boolean | undefined; pbi?: boolean | undefined;
  bcStatus?: string | undefined;
  telemetria?: { mensajes: number; conf: string; delta: string; skills: number; bars: ReadonlyArray<{ k: string; width: string; v: string }> } | undefined;
  rastro?: ReadonlyArray<{ t: string; who: string; resto: ReactNode; opaco?: string | undefined }> | undefined;
}
export const CASAS: Record<string, CasaSeed> = {
  "eng-carnicas-illa": {
    bc: true, bcStatus: "al día · 07:42",
    telemetria: { mensajes: 41, conf: "71%", delta: "+4", skills: 3, bars: [
      { k: "erosion-margen", width: "4.5rem", v: "11" }, { k: "tension-tesoreria", width: "2.5rem", v: "6" }, { k: "politica-descuentos", width: "1.25rem", v: "3" },
    ] },
    rastro: [
      { t: "hoy 12:40", who: "su directivo/a", resto: <>re-confirmó el criterio <b>rappels dentro del margen</b> (vigente desde el 28 jul)</> },
      { t: "28 jul", who: "asesor", resto: <>abrió el seguimiento <b>liquidación de rappels de agosto</b></> },
      { t: "26 jul", who: "su directivo/a", resto: <>apuntó la decisión <b>subida a Horeca Nord</b></> },
      { t: "19 jul", who: "su directivo/a", resto: <>retiró un criterio — </>, opaco: "◌ en revisión: ¿lo indujo un skill? (cola)" },
    ],
  },
  "eng-vielsa": { bc: true, pbi: true },
  "eng-roure": { bc: true },
  "eng-textil-bages": { bc: true },
};
/** Lo sembrado para esta casa — vacío (y honesto) si no hay entrada. */
export function casaDe(slug: string): CasaSeed {
  return CASAS[slug] ?? {};
}
/** ¿Lo que se va a pintar de esta casa sale de la semilla? Para marcarlo «fase dev». */
export function esSembrada(slug: string): boolean {
  return slug in CASAS;
}
